import {Component} from '@angular/core';
import {NavigationEnd, Router, RouterOutlet} from "@angular/router";
import {NavbarComponent} from "./shared/components/navbar/navbar.component";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  standalone: false
})
export class AppComponent {
  title = 'BNP-CLI';
  showNavBar: boolean = false;
  showHomeButton: boolean = false;

  constructor(private router: Router) {
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        if (e.url !== '/login') {
          this.showNavBar = true
          //on n'affiche 'Accueil' que si on n'est pas sur home
          if (e.url !== '/') {
            this.showHomeButton = true;
          }
        } else {
          this.showNavBar = false;
        }
      }
    });
  }


}
